import { Collector, IInitParam } from '@dp/byted-tea-sdk-oversea';
import { pick } from '../object';
import { DEFAULT_TEA_APP_ID, DEFAULT_TEA_CONFIG } from '../constant';
import { TeaConfig } from '../../interface/cookie-banner';

const teaInstance = new Collector('cookie_banner_tea_ui');
let teaInited = false;

export function initTea(teaConfig?: TeaConfig) {
  if (teaInited || !teaInstance) {
    return;
  }

  teaInited = true;
  const config = teaConfig ?? DEFAULT_TEA_CONFIG;
  teaInstance.init({
    app_id: DEFAULT_TEA_APP_ID,
    log: false,
    ...config,
  } as IInitParam);
  teaInstance.start();
}

export function setTeaConfig(attributes: Record<string, string>) {
  if (!teaInited || !teaInstance) {
    return;
  }

  teaInstance.config({
    evtParams: attributes,
  });
}

export function teaReport(eventName: string, attributes = {}) {
  if (!teaInited || !teaInstance) {
    return;
  }

  const referrer = `${location.protocol}//${location.host}${location.pathname}`;
  teaInstance.event(eventName, {
    page_url: referrer,
    host: location.host,
    user_agent: navigator.userAgent,
    referrer,
    ...attributes,
  });
}

export function monitorSelfErrors() {
  const selfSrc = (document.currentScript as HTMLScriptElement)?.src;
  if (selfSrc) {
    window.addEventListener('error', (e: Event) => {
      if (e instanceof ErrorEvent && e.filename === selfSrc) {
        const error = {
          ...pick(e.error, ['name', 'message', 'stack']),
          ...pick(e as unknown as Record<string, string>, ['filename', 'lineno', 'colno']),
        };
        teaReport('cookie_banner_js_error', error);
      }
    });
  }
}
